// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "3e0bd7fe",
    "hash": "3e0bd7fe",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "3e0bd7fe",
    "semverString": null,
    "version": "2.7.5"
};
/* tslint:enable */



// WEBPACK FOOTER //
// ./src/environments/version.ts